import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20theater%20scene%20with%20warm%20golden%20spotlight%20beam%2C%20elegant%20velvet%20curtains%2C%20atmospheric%20dust%20particles%20in%20light%2C%20dramatic%20professional%20cinema%20photography%2C%20rich%20deep%20warm%20tones%2C%20luxurious%20theater%20interior%2C%20moody%20atmosphere%2C%20clean%20elegant%20composition&width=1800&height=1000&seq=hero-bg-main&orientation=landscape"
          alt="爱液视频"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto py-20">
        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-background-50 mb-4 leading-tight">
          精选高清视频
          <br />
          <span className="text-primary-400">随时随地 · 畅享精彩</span>
        </h1>
        <p className="text-background-200 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          爱液视频为您汇集海量高清视频资源，涵盖动作、喜剧、剧情、科幻、纪录、动漫等多种类型，
          每日更新精彩内容，让您的观影体验更加丰富多彩。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
          <Link
            to="/category/dongzuo"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即探索
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 hover:bg-background-50/25 text-background-50 border border-background-50/20 font-medium rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-information-line mr-2"></i>
            了解更多
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">50,000+</p>
            <p className="text-xs text-background-300 mt-1">高清视频资源</p>
          </div>
          <div className="w-px h-10 bg-background-50/20 hidden sm:block"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">200万+</p>
            <p className="text-xs text-background-300 mt-1">日均活跃用户</p>
          </div>
          <div className="w-px h-10 bg-background-50/20 hidden sm:block"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">99.8%</p>
            <p className="text-xs text-background-300 mt-1">用户好评率</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}